// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2fAa4","container":"styles_container__23LYM","title":"styles_title__3lGB7","wrapper":"styles_wrapper__32zOk","answer":"styles_answer__2c8kR"};